<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Edit Product</h1>
   </div>-->
   <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong class="success_msg">{{errorMessage}}</strong>
                </div>
                <div class="alert alert-success succ_msg" v-if="successMessage">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
<ValidationObserver v-slot="{ handleSubmit }">
   <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq">
        <div class="mb-3 row">

            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box mb-3">

                    <div class="card-body">

                        <div class="row">
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Product Number</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <input type="text" class="form-control" placeholder=""  v-model="form.product_num"  id="product_num" name="product_num" />
                                        <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Product Name</label>
                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.product_name">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Old SKU</label>
                                    <input type="text" class="form-control"  placeholder="" name="sku" id="sku" v-model="form.sku" />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Customer SKU</label>
                                    <input type="text" class="form-control"  placeholder="" name="customer_sku" id="customer_sku" v-model="form.customer_sku" />
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group flex-fill">
                                    <label>Product Description</label>
                                    <!--<ckeditor v-model="form.product_desc" :config="editorConfig"></ckeditor>-->
                                    <VueEditor v-model="form.product_desc" :editorToolbar="getXSmallQuillToolbar()"></VueEditor>
                                </div>
                            </div>
                            <!--<div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Product Price</label>
                                    <validation-provider rules="required|positive" v-slot="{ errors }">
                                    <input type="text"  class="form-control" name="address" placeholder="Product Price" v-model="form.price">
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>-->
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Selling Price</label>
                                    <validation-provider rules="required|positive" v-slot="{ errors }">
                                    <input type="text"  class="form-control" name="address" placeholder="" v-model="form.selling">
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Vendor Cost</label>
                                    <validation-provider rules="required|positive" v-slot="{ errors }">
                                    <input type="text"  class="form-control" name="vendor_cost" placeholder="" v-model="form.vendor_cost">
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Vendor</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                    <v-select placeholder="Search Vendor" label="company_name" v-model="form.vendor_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                        <template slot="no-options">
                                        Search Vendor
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>

                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label>Customer</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                    <v-select placeholder="Search Customer" label="company_name" v-model="form.customer_id" :filterable="false" :options="optionsCustomer" :reduce="(optionc) => optionc.id" @search="onCustomerSearch">
                                        <template slot="no-options">
                                        Search Customer
                                        </template>
                                        <template slot="option" slot-scope="optionc">
                                        <div class="d-center">
                                            {{ optionc.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="optionc">
                                        <div class="selected d-center">
                                            {{ optionc.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>

                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group flex-fill">
                                    <label for="status" class="mdl-textfield__label">Status </label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                            <option value="1">Active</option>
                                            <option value="0">InActive</option>
                                        </select>
                                    <span class="error-message">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>

                        </div>

                         <div class="btnrow text-right">
                            <router-link :to="{name: 'viewProducts'}" class="btn btn-danger me-1">Discard</router-link>
                            <button type="submit" :disabled="buttonDisable" class="btn btn-primary" id="save_customer_btn">Save</button>
                            <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
                        </div>

                    </div>
                </div>




            </div>
        </div>

      </div>
   </form>
</ValidationObserver>
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>
<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import { VueEditor } from "vue2-editor";

extend('required', {
  ...required,
  message: 'This field is required'
});
extend('positive', value => {

  if (value >= 0) {
    return true;
  }
  return 'Please enter only number';
});
export default {
    name: "ProductEdit",
    components: {
        ValidationProvider,ValidationObserver, VueEditor
    },
    created() {
        if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomer();
        this.setSuccessMessage(null);
    },
    data(){
        return {
            buttonDisable:false,
            editorConfig: {
                // The configuration of the editor.
                toolbar: [
                    [ 'Font', 'FontSize', '|', 'Bold', 'Italic', 'Underline', 'Styles', '|', 'Format', ],
                ],
                //ui: { top: 10, right: 10, bottom: 10, left: 10},
                removePlugins: 'elementspath',
                line_height: "1px;1.1px;1.2px;1.3px;1.4px;1.5px",
            },
            options:[],
            optionsCustomer:[],
            form: {
                product_name: null,
                price: null,
                product_desc: null,
                product_num: null,
                vendor_id: null,
                customer_id: null,
                selling: null,
                status:"1",
                vendor_cost:null,
                sku: null,
                customer_sku: null,
            },
            submitted: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        onCustomerSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.customerSearch(loading, search, this);
            }
        },
        customerSearch(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Custumer",data.data.data);
                    vm.optionsCustomer = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios.get(window.route('vendors.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('products.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       // this.customerData = data.data;
                        console.log("this.customerData 11",data);
                         this.form = {
                            product_name: data.data.product_name,
                            product_desc: data.data.product_desc,
                            price: data.data.price,
                            product_num: data.data.product_num,
                            vendor_id: data.data.vendor_id,
                            customer_id: data.data.customer_id,
                            selling: data.data.selling,
                            status:data.data.status,
                            vendor_cost:data.data.vendor_cost,
                             sku: data.data.sku,
                             customer_sku: data.data.customer_sku,
                         }
                         if(data.data.vendor){
                            this.options = [
                                {
                                id:data.data.vendor.id,
                                company_name:data.data.vendor.company_name
                                }
                            ];
                         }
                         if(data.data.customer){
                            this.optionsCustomer = [
                                {
                                id:data.data.customer.id,
                                company_name:data.data.customer.company_name
                                }
                            ];
                         }

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addNewContact() {
            this.form.contacts.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

        },
        checkDefault(defIndex,event){
            this.form.contacts.forEach((value, index) => {
                if(defIndex == index){
                    this.form.contacts[index].default_contact = true;
                }
                else{
                    this.form.contacts[index].default_contact = false;
                }
            });
        },
        removeContact(index){
            if(this.form.contacts[index].default_contact == true){
                this.setErrorMessage("Default contact can not be deleted.");
                return false;
            }
            if(this.form.contacts[index].contact_id != null) {

                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('customer.deleteContact', {id: this.form.contacts[index].contact_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            this.form.contacts.splice(index, 1);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            } else {
                this.form.contacts.splice(index, 1);
            }

        },
        addNewNumber(index) {
            this.form.contacts[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
            console.log(this.form.contacts);
        },
        removeNumber(index, contactIndex) {
            this.form.contacts[index].contact_numbers.splice(contactIndex, 1);
        },
        save() {
            this.buttonDisable = true;
            this.submitted = true;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.put(window.route('products.update', {id: this.$route.params.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    console.log(data.errors)
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else if(data.errors){
                        console.log(data.errors)
                        self.setCommonErrors(data.errors);
                    } else {
                        self.setSuccessMessage("Product Updated successfully.");
                       // self.getCustomer();
                       this.buttonDisable = false;
                        setTimeout(() => {
                            self.$router.push({ name: 'viewProducts' });
                        }, 3500);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);
                    this.buttonDisable = false;
                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
